import React from 'react';
import Typography from '@mui/material/Typography';
import { SideBarMenuItemStyled, sx } from './sidebar-menu-item.styled';
import { SidebarMenuItemVariant } from './sidebar-menu-item.constants';

export interface SidebarMenuItemProps {
  selected: boolean;
  button: any;
}

const SidebarMenuItem = (props: SidebarMenuItemProps) => {

  const variant: SidebarMenuItemVariant = props.selected
      ? SidebarMenuItemVariant.Selected
      : SidebarMenuItemVariant.Unselected

  return (
    <SideBarMenuItemStyled.Container
      onClick={props.button.onClick}
      variant={variant}
    >
      <Typography
        color={'black'}
        sx={sx(variant).TypographyMainText}
      >
        {props.button.text}
      </Typography>
    </SideBarMenuItemStyled.Container>
  );
};

export default SidebarMenuItem;
